<template>
    <div id="opening-periods-section" class="periods">
        <div class="tabulation-title" style="margin-bottom: 20px">
            <h5>
                <v-icon>label_outline</v-icon> Période et horaire d'ouverture
            </h5>
        </div>

        <div class="mr-auto ml-auto">
            <div class="mr-auto ml-auto mt-3" v-for="(period, i) in provider.opening_periods">

                <div class="tab-periods mt-3" v-if="period.opening_days.length">
                    <div class="d-flex justify-content-between">
                        <div class="mt-auto mb-auto">
                            <span class="mr-2">
                                Du <b>{{ formatDate(period.valid_from, false) }}</b> au <b>{{
                                formatDate(period.valid_through, false)
                                }}</b>
                            </span>
                        </div>

                        <div>
                            <v-tooltip slot="append-outer" bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" color="red" @click="confirmDelete(i)">delete</v-icon>
                                </template>
                                <span>Supprimer la période d'ouverture</span>
                            </v-tooltip>
                        </div>
                    </div>

                    <v-checkbox v-model="period.h24" label="Ouvert 24h/24" hide-details>
                    </v-checkbox>
                </div>

                <v-expand-transition>
                    <div class="tab-container" v-show="!period.h24">
                        <div v-for="day in period.opening_days" :key="day.day_of_week" class="tab-day">
                            <div class="d-flex d-sm-none justify-content-between">
                                <div class="day mt-auto mb-auto">
                                    <b>{{ daysOfWeek[day.day_of_week] }}</b>
                                </div>

                                <v-switch v-model="day.closed" :label="$data[day.closed ? 'closed' : 'open']"
                                    color="red" class="mt-0" hide-details>
                                </v-switch>

                                <div class="text-center mt-auto mb-auto pr-1">
                                    <v-btn x-small fab color="primary" @click="addHours(day, period)">
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <tbody>
                                            <tr>
                                                <td class="day d-none">
                                                    <b>{{ daysOfWeek[day.day_of_week] }}</b>
                                                </td>
                                                <td class="d-none">
                                                    <v-switch v-model="day.closed"
                                                        :label="$data[day.closed ? 'closed' : 'open']" color="red"
                                                        @change="updateClosed(day, period)" :value="day.closed"
                                                        hide-details>
                                                    </v-switch>
                                                </td>
                                                <td>
                                                    <div class="hours-raw mt-2 mb-2"
                                                        v-for="(hours, i) in day.opening_hours">
                                                        <div class="input-time">
                                                            <div class="d-flex">
                                                                <div class="d-flex">
                                                                    <div class="d-flex">
                                                                        <div class="text-center m-auto prepend-hour">
                                                                            <span class="mr-2 mt-auto mb-auto">de</span>
                                                                        </div>
                                                                        <el-time-select v-model="hours.open"
                                                                            placeholder="--:--" :picker-options="{
                                                                                step: '00:15',
                                                                                start: '00:00',
                                                                                end: '23:45'
                                                                            }">
                                                                        </el-time-select>
                                                                    </div>
                                                                    <div class="d-flex">
                                                                        <div class="text-center m-auto prepend-hour">
                                                                            <span
                                                                                class="ml-2 mr-2 mt-auto mb-auto">à</span>
                                                                        </div>
                                                                        <el-time-select v-model="hours.close"
                                                                            :value="hours.close" placeholder="--:--"
                                                                            :picker-options="{
                                                                                step: '00:15',
                                                                                start: '00:00',
                                                                                end: '23:45',
                                                                                minTime: hours.open
                                                                            }">
                                                                        </el-time-select>
                                                                    </div>

                                                                </div>

                                                                <div style="width: 36px" class="mt-auto mb-auto">

                                                                    <v-tooltip slot="append-outer" bottom>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-btn color="error" class="ml-2" small icon
                                                                                v-on="on" @click="deleteHours(day, i)">
                                                                                <v-icon>delete</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Supprimer la tranche horaire</span>
                                                                    </v-tooltip>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>

                                <div class="text-center mt-auto mb-auto pr-1 d-none add-period">
                                    <v-btn text color="primary" class="text-none" @click="addHours(day, period)">
                                        <v-icon>add</v-icon> Ajouter des horaires d'ouverture
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-expand-transition>
            </div>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import Confirm from "../../../tools/Confirm"

export default {
    name: "OpeningPeriod",
    components: { Confirm },
    props: ["provider"],
    data() {
        return {
            daysOfWeek: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
        }
    },
    methods: {
        updateClosed(day, period) {
            if (day.opening_hours === undefined) {
                this.$set(day, 'opening_hours', [])
            }

            if (day.closed !== true && day.opening_hours.length === 0) {
                this.addHours(day, period)
            }

            if (day.closed) {
                day.opening_hours = []
            }

            this.$forceUpdate()
        },
        addHours(day, period) {
            let createNew = false

            if (day.opening_hours === undefined) {
                this.$set(day, 'opening_hours', [])
            }

            if (!day.opening_hours.length) {
                let lastDayIndexWithHours = this.getLastDayIndexWithHours(day, period)

                if (lastDayIndexWithHours !== null) {
                    let lastDay = period.opening_days[lastDayIndexWithHours]

                    if (lastDay.opening_hours.length) {
                        lastDay.opening_hours.forEach(range => {
                            let hour = {}

                            this.$set(hour, 'open', range.open)
                            this.$set(hour, 'close', range.close)

                            day.opening_hours.push(hour)
                        })
                    }
                } else {
                    createNew = true
                }
            } else {
                createNew = true
            }

            if (createNew) {
                let hours = {}

                this.$set(hours, 'open', '')
                this.$set(hours, 'close', '')

                day.opening_hours.push(hours)
            }

            day.closed = false

            this.$forceUpdate()
        },
        getLastDayIndexWithHours(day, period) {
            let median = null
            let i = null

            period.opening_days.forEach((_day, index) => {
                if (_day === day) {
                    median = index
                }
            })

            period.opening_days.forEach((_day, index) => {
                if (index < median && _day.opening_hours !== undefined && _day.opening_hours.length) {
                    i = index
                }
            })

            return i >= 0 ? i : null
        },
        confirmDelete(index) {
            let period = this.provider.opening_periods[index]

            this.$refs.confirm.open('Attention',
                'Vous allez supprimer les horaires saisies pour la période du ' + this.formatDate(period.valid_from, false) +
                ' au ' + this.formatDate(period.valid_through, false) + '. ' +
                'Êtes-vous sûr de vouloir supprimer cette période ?',
                { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        let index = this.provider.opening_periods.findIndex((_period) => _period === period)
                        this.deletePeriod(index)
                    }
                })
        },
        deletePeriod(index) {
            this.provider.opening_periods.splice(index, 1)

            this.$forceUpdate()
        },
        deleteHours(day, index) {
            day.opening_hours.splice(index, 1)

            this.$forceUpdate()
        }
    }
}
</script>